import React from "react";
import OtherInformationForm from "./other-information-form";

function OtherInformationWrapper({
    onBack,
    onNextStep,
    formData,
    setReportData,
    setAlertDetails,
}) {
    const initialValues = {
        odiDropPercentage: formData?.odiDropPercentage ?? "",
        odiDropTime: formData?.odiDropTime ?? "",
        t1Score: formData?.t1Score ?? "",
        t2Score: formData?.t2Score ?? "",
    };

    return (
        <div>
            <OtherInformationForm
                onBack={onBack}
                onNextStep={onNextStep}
                formData={formData}
                initialValues={initialValues}
                setReportData={setReportData}
                setAlertDetails={setAlertDetails}
            />
        </div>
    );
}

export default OtherInformationWrapper;
